import { useEffect, useState } from "react";
import AdminLayout from "@/components/layout/AdminLayout";
import api from "@/lib/api";
import { formatDateTime, formatMoney } from "@/lib/format";

const STATUS_COLOR = {
  initiated: "bg-white/[0.08] text-white",
  paid: "bg-[color:var(--bd-green)]/20 text-[color:var(--bd-green-bright)]",
  expired: "bg-[color:var(--bd-red)]/15 text-[color:var(--bd-red-bright)]",
};

export default function CustomPayments() {
  const [list, setList] = useState([]);

  useEffect(() => {
    api.get("/custom-payments").then((r) => setList(r.data)).catch(() => {});
  }, []);

  const totalPaid = list.filter((p) => p.status === "paid").reduce((s, p) => s + p.amount, 0);

  return (
    <AdminLayout title="Quick Payments">
      <div className="mb-6 grid sm:grid-cols-3 gap-4">
        <Stat label="Total" value={list.length} />
        <Stat label="Paid count" value={list.filter((p) => p.status === "paid").length} />
        <Stat label="Total received" value={formatMoney(totalPaid, "SEK")} accent />
      </div>
      <div className="rounded-2xl border border-white/10 bg-white/[0.02] overflow-x-auto">
        <table className="w-full text-sm" data-testid="custom-payments-table">
          <thead className="bg-white/[0.03] text-xs uppercase tracking-[0.15em] text-[color:var(--ivory-muted)]">
            <tr>
              <th className="px-4 py-3 text-left">When</th>
              <th className="px-4 py-3 text-left">Name</th>
              <th className="px-4 py-3 text-left">Email</th>
              <th className="px-4 py-3 text-left">For</th>
              <th className="px-4 py-3 text-right">Amount</th>
              <th className="px-4 py-3 text-left">Status</th>
            </tr>
          </thead>
          <tbody>
            {list.map((p) => (
              <tr key={p.id} className="border-t border-white/5 hover:bg-white/[0.02]" data-testid={`custom-payment-row-${p.id}`}>
                <td className="px-4 py-3 text-[color:var(--ivory-muted)] whitespace-nowrap">{formatDateTime(p.created_at)}</td>
                <td className="px-4 py-3 font-medium">{p.name}</td>
                <td className="px-4 py-3">{p.email}</td>
                <td className="px-4 py-3 max-w-xs truncate" title={p.description}>{p.description || "—"}</td>
                <td className="px-4 py-3 text-right font-medium">{formatMoney(p.amount, p.currency)}</td>
                <td className="px-4 py-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs uppercase tracking-wide ${STATUS_COLOR[p.status] || STATUS_COLOR.initiated}`}>
                    {p.status}
                  </span>
                </td>
              </tr>
            ))}
            {list.length === 0 && <tr><td colSpan="6" className="p-12 text-center text-[color:var(--ivory-muted)]">No quick payments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminLayout>
  );
}

function Stat({ label, value, accent }) {
  return (
    <div className={`p-4 rounded-2xl border ${accent ? "border-[color:var(--bd-green)]/30 bg-[color:var(--bd-green)]/5" : "border-white/10 bg-white/[0.02]"}`}>
      <div className="text-xs uppercase tracking-[0.2em] text-[color:var(--ivory-muted)]">{label}</div>
      <div className="font-display text-2xl mt-2">{value}</div>
    </div>
  );
}
